import { Box} from '@mui/material';
import { makeStyles } from '@mui/styles';

import React, { useContext, useEffect, useState } from 'react';

import { AppContext } from '../../../../../RoutesWithAuth';

import ListOfItems from '../ListOfItems';

import axios from '../../../../common/AxiosConfig';

import ResponseJsonContent from './ResponseJsonContent';

import { getFormatedDate } from '../../../../common/commons';

import DeleteDialog from '../../admin/settings/DeleteDialog';

import { HOME_PERMISSIONS } from '../../../../common/RolePermissions';

const listOfItemsData = [{
    display: "Automated Upload Attempts",
    mapping: "auto_upload_attempts"
}, {
    display: "Manual Upload Attempts",
    mapping: "manual_upload_attempts",

}, {
    display: "Attachments Placed In FTP",
    tooltip: "ftp_placed_time_local",
    mapping: "ftp_placed_time_utc"
}, {
    display: "Aggregated Response Sent",
    tooltip: "tips_ack_time_local",
    mapping: "tips_ack_time_utc"

}, {
    display: "Acknowledgement Received",
    tooltip: "tips_ack_time_local",
    mapping: "tips_ack_time_utc"

}]
const useStyles = makeStyles(() => ({
    root: {
        '& .customLink': {
            textDecoration: "underline",
        },
        '& .customselectInput .MuiSelect-root': {
            paddingTop: '10.5px',
            paddingBottom: '10.5px'

        }
    },
    "attachmentsWrapper": {
        marginLeft: "10px",
        marginRight: "10px",
        '& .header': {
            background: '#7f9ed7',
            padding: '5px',
            color: "white",
            fontWeight: 'bold'
        },
    },
    tableWrapper: {
        overflow: 'auto',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        marginTop: '10px',
        '& table': {
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: '0.85rem',
        },
        '& thead': {
            background: '#778899',
            position: 'sticky',
            top: 0,
            zIndex: 10,
        },
        '& th': {
            padding: '12px 16px',
            textAlign: 'left',
            color: '#fff',
            fontWeight: 600,
            fontSize: '0.85rem',
            borderRight: '1px solid rgba(255,255,255,0.1)',
            letterSpacing: '0.3px',
            position: 'sticky',
            top: 0,
            background: '#778899',
            userSelect: 'none',
            zIndex: 9,
            '&:last-child': {
                borderRight: 'none',
            },
        },
        '& .resize-handle': {
            position: 'absolute',
            right: 0,
            top: 0,
            bottom: 0,
            width: '8px',
            cursor: 'col-resize',
            userSelect: 'none',
            zIndex: 1,
            '&:hover': {
                background: 'rgba(255,255,255,0.2)',
            },
        },
        '& tbody tr': {
            background: '#fff',
            borderBottom: '1px solid #edf2f7',
            transition: 'background-color 0.2s ease',
            '&:nth-of-type(odd)': {
                background: '#f8fafc',
            },
            '&:hover': {
                background: '#f0f7ff',
            },
        },
        '& td': {
            padding: '12px 16px',
            borderRight: '1px solid #edf2f7',
            color: '#334155',
            fontSize: '0.85rem',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            '&:last-child': {
                borderRight: 'none',
            },
        },
    }
}));


const ConsolidatedResponse = ({ tabInfo, setDisplayErrMsg, setLoading, handleNewTabOpen, reloadInformation }) => {
    const context = useContext(AppContext);
    const authToken = context.authToken.get;
    const classes = useStyles();

    const [responseData, setResponseData] = useState({});
    const [openReuploadConfirmation, setOpenReuploadConfirmation] = useState(false);
    const [columnWidths, setColumnWidths] = useState({});

    useEffect(() => {
        fetchData();
   
  // eslint-disable-next-line react-hooks/exhaustive-deps
},[tabInfo.tabtype, tabInfo.app_id]);

    const fetchData = () => {
        setLoading(true);
        return axios.get(`ticket/${tabInfo.dsarRequestId}/complete-response`, {
            headers: {
                Authorization: authToken
            }
        }).then(res => {
            setLoading(false);
            const responseData = res.data;
            let ftp_placed_time_local = getFormatedDate(responseData.tips?.ftp_placed_time);
            let ftp_placed_time_utc = getFormatedDate(responseData.tips?.ftp_placed_time, true);
            if (responseData.system_attachments.length === 0) {
                ftp_placed_time_utc = "No attachments to upload";
                ftp_placed_time_local = ""
            }
            setResponseData({
                ...responseData,
                tips: {
                    ...responseData.tips,
                    ftp_placed_time_local: ftp_placed_time_local,
                    ftp_placed_time_utc: ftp_placed_time_utc,
                    auto_upload_attempts: responseData.tips.auto_upload_attempts || "0",
                    manual_upload_attempts: responseData.tips.manual_upload_attempts || "0",
                    tips_ack_time_local: getFormatedDate(responseData.tips?.tips_ack_time),
                    tips_ack_time_utc: getFormatedDate(responseData.tips?.tips_ack_time, true)
                }

            });
            reloadInformation();
        }).catch(err => {
            setLoading(false);
            if (err?.response?.data?.message) {
                setDisplayErrMsg(err.response.data.message)
            }
        })
    }

    const handleDeleteDialogClose = () => {
        setOpenReuploadConfirmation(false);
    }
    const handleDeleteDialogSubmit = () => {
        setOpenReuploadConfirmation(false);
        setLoading(true);
        axios.post("response/resend_tips", {
            dsar_id: tabInfo.dsarRequestId
        }, {
            headers: {
                Authorization: authToken
            }
        }).then(res => {
            fetchData();
            setLoading(false);
        }).catch(err => {
            setLoading(false);
            if (err.response?.data) {
                setDisplayErrMsg(err.response.data.message)
            }
        })
    }
    const getAllFilesData = () => {
        let sortedAttachments = responseData?.system_attachments?.sort((a, b) => a.app_name.localeCompare(b.app_name) || a.filename.localeCompare(b.filename)) || [];
        return sortedAttachments.map((attachment, index) => {
            return {
                ...attachment,
                id: index + 1,
            }
        });
    }
    return (<Box className={`${classes.root} requestDetailsWrapper`} width={"100%"} height={"100%"} >
        <ListOfItems
            items={[...listOfItemsData,
            {
                display: "View Response",
                type: "custom",
                renderCustom: () => {
                    return (
                        <a
                            href="void(0)"
                            className='customLink'
                            data-testid={"fileUploadLink"}
                            onClick={(event) => {
                                event.preventDefault();
                                handleNewTabOpen({
                                    "tabname": "DSAR RESPONSE",
                                    "tabtype": "dsarResponse",
                                    "activeSelection": "viewdsarResponse",
                                    closeIndex: 2,
                                })
                            }}
                        >
                            response.json
                        </a>
                    )
                }
            }, {
                display: "Reupload Response",
                type: "button",
                text: "Reupload",
                permission: HOME_PERMISSIONS.REUPLOAD,
                handleCallback: () => {
                    setOpenReuploadConfirmation(true);
                }
            }]}
            data={responseData?.tips || {}}
        />
        <DeleteDialog
            openDeleteDialog={openReuploadConfirmation}
            title={"Confirmation"}
            handleDeleteDialogClose={handleDeleteDialogClose}
            handleDeleteDialogSubmit={handleDeleteDialogSubmit}
            closeButtonText={"No"}
            submitButtonText={"Yes"}
        >
            Do you really want to re-upload the response to TIPS/QB64?

        </DeleteDialog>
        {responseData?.system_attachments?.length > 0 && (
            <div data-testid={"attachmentsWrapper"} className={classes.attachmentsWrapper}>
                <div className={"header"}>
                    Attachments
                </div>
                <Box padding={"10px"}>
                    <div className={classes.tableWrapper}>
                        <table>
                            <thead>
                                <tr>
                                    {[
                                        { name: "#", mapping: "id", width: 50 },
                                        { name: "File Name", mapping: "filename", width: 250 },
                                        { name: "Downstream", mapping: "app_name", width: 120 }
                                    ].map((col) => {
                                        const currentWidth = columnWidths[col.mapping] || col.width || 150;
                                        return (
                                            <th
                                                key={col.mapping}
                                                style={{
                                                    width: currentWidth,
                                                    minWidth: col.width || 100
                                                }}
                                            >
                                                {col.name}
                                                <div
                                                    className="resize-handle"
                                                    onMouseDown={(e) => {
                                                        e.preventDefault();
                                                        const startX = e.clientX;
                                                        const startWidth = currentWidth;

                                                        const handleMouseMove = (e) => {
                                                            const diff = e.clientX - startX;
                                                            const newWidth = Math.max(col.width || 50, startWidth + diff);
                                                            setColumnWidths(prev => ({
                                                                ...prev,
                                                                [col.mapping]: newWidth
                                                            }));
                                                        };

                                                        const handleMouseUp = () => {
                                                            document.removeEventListener('mousemove', handleMouseMove);
                                                            document.removeEventListener('mouseup', handleMouseUp);
                                                        };

                                                        document.addEventListener('mousemove', handleMouseMove);
                                                        document.addEventListener('mouseup', handleMouseUp);
                                                    }}
                                                />
                                            </th>
                                        );
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {getAllFilesData().map((row, index) => (
                                    <tr key={row.id || index}>
                                        <td title={row.id}>{row.id}</td>
                                        <td title={row.filename}>
                                            <a
                                                href="void(0)"
                                                className='customLink'
                                                data-testid={"fileNameLink"}
                                                onClick={(event) => {
                                                    event.preventDefault();
                                                    handleNewTabOpen({
                                                        "tabname": row.filename,
                                                        "tabtype": "word",
                                                        "activeSelection": `${row.filename}-fileViewer`,
                                                        closeIndex: 2,
                                                        hideregenerateWordDoc: true,
                                                        "downloadFileName": row.filename,
                                                        "signedUrlEndPoint": `ticket/response/download/${row.s3_key}`
                                                    })
                                                }}
                                            >
                                                {row.filename}
                                            </a>
                                        </td>
                                        <td title={row.app_name}>{row.app_name}</td>
                                    </tr>
                                ))}
                                {getAllFilesData().length === 0 && (
                                    <tr>
                                        <td colSpan={3} style={{ textAlign: 'center', padding: '20px', color: '#64748b' }}>
                                            No attachments available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </Box>
            </div>)}
        <ResponseJsonContent
            responseData={{
                response_json: responseData?.tips?.tips_ack_json,
                fileName: `${tabInfo.dsarRequestId}_Upstream_Ack.json`
            }}
            tabInfo={tabInfo}
        />
    </Box>)
}
export default React.memo(ConsolidatedResponse);

